import types from './types';

const getRequiredCompetencies = () => ({
  type: types.GET_REQUIRED_COMPETENCIES
});

export default {
  getRequiredCompetencies
};
